import { FC, useEffect, useState } from "react";
import styles from "./Alert.module.scss";
import { Alert, useAlert } from "../Alert";
import { AlertData } from "./context";
import { animated, useTransition } from "react-spring";

/**
 * The alert container properties.
 */
export interface AlertContainerProps {
  /**
   * The current alert data.
   */
  readonly currentAlert: AlertData | null;
}

/**
 * The alert container component.
 * @deprecated Please use the component in `capitalrx-components-2.0/lib/general`.
 */
export const AlertContainer: FC<AlertContainerProps> = (props: AlertContainerProps): JSX.Element => {
  const { currentAlert } = props;
  const [activeAlert, setActiveAlert] = useState<AlertData | null>(null);

  const transitions = useTransition(activeAlert ? [activeAlert] : [], {
    from: { opacity: 0, translateY: "-100%" },
    enter: { opacity: 1, translateY: "0%" },
    leave: { opacity: 0, translateY: "-100%" },
    config: {
      duration: 200,
    },
  });

  const [, hideAlert] = useAlert();

  useEffect(() => {
    setActiveAlert(currentAlert);

    const timer = setTimeout(() => {
      hideAlert();
    }, currentAlert?.timeout || 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [currentAlert]);

  return (
    <>
      {transitions((style, alert) => (
        <animated.div className={styles.alertContainer} data-testid={"test__alert-container"} style={style}>
          <Alert message={alert.message} style={alert.style} type={alert.type} />
        </animated.div>
      ))}
    </>
  );
};
